import React from 'react';
import { useMutation } from 'react-query';
import { useRouter } from 'next/router';
import UseToast from 'hooks/use-toast';
import { LecturePurchase } from 'services/core';
import ActionButton from '@core/components/actionbutton/ActionButton';
import { getErrorText } from 'utils/geterrortext';

import { ArrowRight2 } from 'iconsax-react';

import classes from './CoursePurchaseGate.module.scss';

const PREMIUM_FEATURES = [
	'All courses and career paths',
	'All quizzes and certificates',
	'All learning tools and assessments',
	'Cancel anytime'
];

const CoursePurchaseGate = ({ lecture_id, lecture_title, purchase_option, onClose, compact }) => {
	const router = useRouter();
	const { toast, ToastContainer } = UseToast();

	const { mutate: purchaseLecture, isLoading: purchaseLoading } = useMutation(
		LecturePurchase,
		{
			onSuccess: (data) => {
				window.location.href = data.data.link;
			},
			onError: (error) => {
				if (error.response?.status === 401) {
					router.push(`/login?next=${router.asPath}`);
					return;
				}
				const message = error.response?.data?.data || getErrorText(error);
				toast(message, 'Alert');
			}
		}
	);

	return (
		<div className={`${classes['gate']} ${compact ? classes['gate--compact'] : ''}`}>
			<ToastContainer />
			{lecture_title && (
				<h2 className={classes['gate__title']}>Start learning {lecture_title}</h2>
			)}

			<div className={classes['gate__premium-card']}>
				<h3 className={classes['gate__premium-card__header']}>Subscribe to Pharmuni Premium</h3>
				<ul className={classes['gate__features']}>
					{PREMIUM_FEATURES.map((feature) => (
						<li key={feature} className={classes['gate__features__item']}>
							<span className={classes['gate__check']} />
							{feature}
						</li>
					))}
				</ul>
				<ActionButton
					className={classes['gate__premium-btn']}
					onClick={() => {
						onClose?.();
						router.push('/plans');
					}}
				>
					Start Learning with Premium
				</ActionButton>
			</div>

			{purchase_option && (
				<>
					<div className={classes['gate__divider']}>
						<span>Or</span>
					</div>
					<button
						className={classes['gate__single-card']}
						onClick={() => purchaseLecture(lecture_id)}
						disabled={purchaseLoading}
					>
						<div className={classes['gate__single-card__info']}>
							<strong>Buy this course</strong>
							<span>Pay once and access this course, its quiz, and certificate.</span>
						</div>
						<span className={classes['gate__single-card__price']}>
							{purchaseLoading ? (
								'...'
							) : (
								<>
									Buy for {purchase_option.currency.symbol}{purchase_option.amount_due}
									<ArrowRight2 size="20" />
								</>
							)}
						</span>
					</button>
				</>
			)}
		</div>
	);
};

export default CoursePurchaseGate;
